import type { ToolbarTitleProps } from './toolbar-title.types.ts';
import styles from './toolbar-title.module.scss';

export function ToolbarTitle({ children, flex = 0 }: ToolbarTitleProps) {
  return (
    <span className={styles.title} style={{ flex: `${flex} ${flex} auto` }}>
      {children}
    </span>
  );
}
